import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import update from 'immutability-helper';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { getSelfFromResourceLinks } from '../../../shared/utils/link';
import {
    clearErrorMessage,
    clearManifests,
    getIsFetching,
    getManifests,
    getManifestsSearchForm,
    loadManifests,
    storeSearch,
} from '../duck';
import ManifestsTable from './components/ManifestsTable';
import ManifestSearch from './components/ManifestSearch';
import { INITIAL_MANIFEST_SEARCH_FORM } from '../duck';
import { createManifestsListBreadcrumb } from '../../../shared/utils/breadcrumbs';
import queryString from 'query-string';

class Manifests extends React.Component {
    componentDidMount() {
        const { query } = this.props.location;

        // Read the search query parameters, prefill our search form
        if (query !== undefined && !isEmpty(query)) {
            const runDate = moment(query.runDate);
            const form = update(INITIAL_MANIFEST_SEARCH_FORM, {
                routeCode: { $set: query.routeCode }, // if it comes from a run it shouldn't include other filters
                runDate: {
                    $set: runDate.isValid() ? runDate : '',
                },
                runSequence: { $set: query.runSequence },
            });
            this.props.storeSearch(form);
            // ... and fetch the manifests!
            this.props.loadManifests(form);
        }
        const { manifests } = this.props;
        if (manifests && manifests.length > 0) {
            const { manifestsSearchForm } = this.props;
            this.props.loadManifests(manifestsSearchForm);
        }
    }

    componentWillUnmount() {
        this.props.clearErrorMessage();
    }

    handleChange = e => {
        const value =
            e.currentTarget.type === 'checkbox' ? e.currentTarget.checked : e.currentTarget.value;
        const form = update(this.props.manifestsSearchForm, {
            [e.currentTarget.name]: { $set: value },
        });
        this.props.storeSearch(form);
    };

    handleDateChange = name => date => {
        const form = update(this.props.manifestsSearchForm, {
            [name]: {
                $set: date,
            },
        });
        this.props.storeSearch(form);
    };

    handleManifestClick = manifest => {
        const link = getSelfFromResourceLinks(manifest);
        this.props.router.push(link);
    };

    handleSubmit = e => {
        e.preventDefault();
        const { manifestsSearchForm } = this.props;
        this.props.loadManifests(this.prepareFormDataForPost(manifestsSearchForm));
    };

    handleReset = () => {
        this.props.storeSearch(INITIAL_MANIFEST_SEARCH_FORM);
        this.props.clearManifests();
    };

    prepareFormDataForPost = form => {
        return update(form, {
            runDate: {
                $set: form.runDate ? moment(form.runDate).format('YYYY-MM-DD') : '',
            },
            pLaneExit: {
                $set: form.pLaneExit ? moment(form.pLaneExit).toISOString() : '',
            },
        });
    };

    prepareDataFormForEPSReport = form => {
        update(form, {
            runDate: {
                $set: form.runDate ? moment(form.runDate).format('YYYY-MM-DD') : '',
            },
            pLaneExit: {
                $set: form.pLaneExit ? moment(form.pLaneExit).toISOString() : '',
            },
        });
        let momentDate = moment(form.runDate);
        let pLaneMomentDate = moment(form.pLaneExit);
        form.runDate = momentDate.isValid() ? momentDate.format('YYYY-MM-DD') : '';
        form.pLaneExitSpecial = pLaneMomentDate.isValid() ? moment(form.pLaneExit).toISOString() : '';
        form.fileName = 'EPS_report_'+form.runDate;
        return queryString.stringify(form);
    };

    render() {
        const { isFetching, manifests, manifestsSearchForm } = this.props;
        const showEpsDownload = true;
        return (
            <div>
                {createManifestsListBreadcrumb()}
                <Row>
                    <Col xs={12}>
                        <ManifestSearch
                            search={manifestsSearchForm}
                            isFetching={isFetching}
                            handleChange={this.handleChange}
                            handleSubmit={this.handleSubmit}
                            handleReset={this.handleReset}
                            handleDateChange={this.handleDateChange}
                            prepareDataFormForEPSReport={this.prepareDataFormForEPSReport}
                            showEpsDownload={showEpsDownload}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} style={{ marginTop: 20 }}>
                        <ManifestsTable
                            manifests={manifests}
                            isFetching={isFetching}
                            onManifestClick={this.handleManifestClick}
                            sortName={manifestsSearchForm.sortParam}
                            sortOrder={manifestsSearchForm.sortDirection}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default withRouter(
    connect(
        state => ({
            manifests: getManifests(state),
            manifestsSearchForm: getManifestsSearchForm(state),
            isFetching: getIsFetching(state),
        }),
        {
            loadManifests,
            storeSearch,
            clearErrorMessage,
            clearManifests,
        }
    )(Manifests)
);
